'use client';

import type { SessionStatusResponse } from '../../../types/sessionStatus.types';
import { BoletoTrackingStatus } from '../../boletoTrackingStatus/boletoTrackingStatus';
import { PixTrackingStatus } from '../../pixTrackingStatus';

interface StatusPageLeftContentProps {
  sessionData: SessionStatusResponse;
  paymentMethod: string;
  orderNotPaid: boolean;
}

export function StatusPageLeftContent({
  sessionData,
  paymentMethod,
  orderNotPaid,
}: StatusPageLeftContentProps) {
  if (!orderNotPaid) return null;

  if (paymentMethod === 'pix') {
    const pixPayment = sessionData?.payments?.[0]?.pix;

    return (
      <PixTrackingStatus
        qrCodeImg={pixPayment?.qr_code_url}
        qrCodeText={pixPayment?.qr_code}
        expirationDate={pixPayment?.expires_at}
      />
    );
  }

  if (paymentMethod === 'boleto') {
    const boletoPayment = sessionData?.payments?.[0]?.boleto;

    return (
      <BoletoTrackingStatus
        barcodeImg={boletoPayment?.barcode}
        barcodeText={boletoPayment?.line}
        expirationDate={boletoPayment?.due_at}
        documentUrl={boletoPayment?.url}
      />
    );
  }

  return null;
}
